import { CountryInterface } from '@app/core/interfaces';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';

/** @deprecated use OutCountriesModule from outshared-lib */
export const LOAD_COUNTRIES = type('[country] load');
/** @deprecated use OutCountriesModule from outshared-lib */
export const LOAD_COUNTRIES_SUCCESS = type('[country] load success');
/** @deprecated use OutCountriesModule from outshared-lib */
export const LOAD_COUNTRIES_ERROR = type('[country] load error');
/** @deprecated use OutCountriesModule from outshared-lib */
export const RESET = type('[country] reset');

/** @deprecated use OutCountriesModule from outshared-lib */
export class LoadCountries implements Action {
    readonly type = LOAD_COUNTRIES;
}

/** @deprecated use OutCountriesModule from outshared-lib */
export class LoadCountriesSuccess implements Action {
    readonly type = LOAD_COUNTRIES_SUCCESS;

    constructor(public payload: { countries: CountryInterface[] }) {}
}

/** @deprecated use OutCountriesModule from outshared-lib */
export class LoadCountriesError implements Action {
    readonly type = LOAD_COUNTRIES_ERROR;

    constructor(public payload: { errors: NotificationInterface[] }) {}
}

/** @deprecated use OutCountriesModule from outshared-lib */
export class Reset implements Action {
    readonly type = RESET;
}

/** @deprecated use OutCountriesModule from outshared-lib */
export type CountryActions = LoadCountries | LoadCountriesSuccess | LoadCountriesError | Reset;
